import { useEffect, useRef, useState } from "react";
import { Alert, Card, Grid } from "@mui/material";
import { Download } from "@mui/icons-material";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { t } from "i18next";
import AppConfig from "../../../../../../helpers/constants/AppConfig";
import MDButton from "../../../../../../components/MDs/MDButton";
import { bTh, mTh } from "../../../../../../helpers/functions/report-table";
import "./statistic-table.css";

export default function TableStatistic({ data, unit, isTotal }) {
  const tableRef = useRef(null);
  const [err, setErr] = useState([]);

  useEffect(() => {
    if (data) {
      const errs = [];
      data.map(d => {
        if (d.report === "Error") {
          errs.push(d.name);
        }
      });
      setErr(errs);
    }
  }, [data]);

  return (
    <Grid item xs={12}>
      <Card sx={{ height: "100%", py: 4, px: 2 }} className="card-st">
        <div className="statistic-table">

          <div className="d-flex w-100 justify-content-end mb-3">
            <DownloadTableExcel
               filename={`statistics_${new Date().getTime()}`}
               sheet="statistics"
               currentTableRef={tableRef.current}
            >
              <MDButton className="excel-download"
                        variant="contained" color={AppConfig.color} size="small"
              >
                {t("global.excel_download")}
                &nbsp; <Download />
              </MDButton>
            </DownloadTableExcel>
          </div>

          <div className="statistic-table-container">
            <table ref={tableRef}>
              <thead>
              <tr>
                {!isTotal && <th rowSpan="2" className="td-sticky">سایت</th>}
                <th colSpan="5">درخواست‌ها</th>
                <th colSpan="4">از مبدا</th>
                <th colSpan="3">کش</th>
                <th colSpan="4">کد وضعیت</th>
              </tr>
              <tr>
                <th>تعداد</th>
                <th>کامل ‌شده</th>
                <th>ناتمام</th>
                <th>حجم</th>
                <th>زمان</th>

                <th>حجم ارسال</th>
                <th>حجم دریافت</th>
                <th>زمان اتصال</th>
                <th>زمان پاسخگویی</th>

                <th>موجود در کش</th>
                <th>ناموجود در کش</th>
                <th>منقضی شده</th>

                <th>2xx</th>
                <th>3xx</th>
                <th>4xx</th>
                <th>5xx</th>
              </tr>
              </thead>

              <tbody style={{ direction: 'ltr' }}>
              {data.map((d, i) => {
                const report = isTotal ? d : d.report;
                if (report !== "Error") {
                  return (
                    <tr key={`dt-${i}`}>
                      {!isTotal && <td className="td-sticky">{d.name}</td>}

                      <td>{report.requests}</td>
                      <td>{report.completed}</td>
                      <td>{report.cancelled}</td>
                      <td>{bTh(parseFloat(report.bytes_sent), unit)}</td>
                      <td>{mTh(parseFloat(report.request_time))}</td>

                      <td>{bTh(parseFloat(report.upstream_bytes_sent), unit)}</td>
                      <td>{bTh(parseFloat(report.upstream_bytes_received), unit)}</td>
                      <td>{mTh(parseFloat(report.upstream_connect_time))}</td>
                      <td>{mTh(parseFloat(report.upstream_response_time))}</td>

                      <td>{report.hit}</td>
                      <td>{report.miss}</td>
                      <td>{report.expired}</td>

                      <td>{report.status2}</td>
                      <td>{report.status3}</td>
                      <td>{report.status4}</td>
                      <td>{report.status5}</td>
                    </tr>
                  )
                }
              })}
              </tbody>
            </table>
          </div>

          {err.length > 0 &&
            <Grid item md={12} mt={4}>
              <Alert severity="error">
                خطا در دریافت آمار
                {" "}
                {err.map((error, i) => {
                  let e = error;
                  if (i !== err.length-1) e += " - "
                  return e;
                })}
                !
              </Alert>
            </Grid>
          }

        </div>
      </Card>
    </Grid>
  )
}
